// src/contexts/produtos/combos/ProdutoApresentacaoContext.js
import React, { createContext, useContext, useRef, useState, useCallback } from 'react';
import { postData, putData, deleteData } from '../../../services/Api';
import { buscarApresentacoesPorProduto } from '../../../services/produtos/ProdutoApresentacaoService';
import { useAlert } from '../../geral/AlertContext';
import { useMessage } from '../../geral/MessageContext';

const ProdutoApresentacaoContext = createContext();

export const useProdutoApresentacao = () => useContext(ProdutoApresentacaoContext);

export const ProdutoApresentacaoProvider = ({ children }) => {
    const [produtoApresentacoes, setProdutoApresentacoes] = useState([]);
    const consultaRef = useRef({ produtoId: 0 });
    const { showAlert } = useAlert();
    const { showMessage } = useMessage();

    const fetchProdutoApresentacoes = useCallback(async (produtoId) => {
        const consulta = { produtoId: Number(produtoId) || 0 };
        consultaRef.current = consulta;
        setProdutoApresentacoes([]);
        if (!consulta.produtoId) return;

        try {
            const result = await buscarApresentacoesPorProduto(produtoId);
            if (consultaRef.current === consulta) setProdutoApresentacoes(result || []);
        } catch (error) {
            if (consultaRef.current !== consulta) return;
            console.error("Erro ao buscar apresentações do produto:", error);
            showMessage(`Erro ao buscar apresentações do produto! ${error?.message || error}`, 'danger');
        }
    }, [showMessage]);

    const addProdutoApresentacao = async (item) => {
        try {
            const result = await postData('/ProdutoApresentacao', item);
            if (consultaRef.current.produtoId === Number(item.produtoId)) {
                setProdutoApresentacoes(atuais => [...atuais, result]);
            }
            showAlert('Apresentação adicionada ao produto com sucesso!');
        } catch (error) {
            console.error("Erro ao adicionar apresentação ao produto:", error);
            showMessage('Erro ao adicionar apresentação ao produto!\n' + error, 'danger');
        }
    };

    const updateProdutoApresentacao = async (item) => {
        try {
            const result = await putData('/ProdutoApresentacao', item);
            setProdutoApresentacoes((prev) =>
                prev.map((i) => (i.id === result.id ? result : i))
            );
            showAlert('Apresentação do produto alterada com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar apresentação do produto:", error);
            showAlert('Erro ao alterar apresentação do produto!', 'danger');
        }
    };

    const deleteProdutoApresentacao = async (id) => {
        try {
            await deleteData('/ProdutoApresentacao', { id });
            setProdutoApresentacoes(atuais => atuais.filter(i => i.id !== id));
            showAlert('Apresentação do produto excluída com sucesso!');
        } catch (error) {
            console.error("Erro ao excluir apresentação do produto:", error);
            showAlert('Erro ao excluir apresentação do produto!', 'danger');
        }
    };

    return (
        <ProdutoApresentacaoContext.Provider value={{
            produtoApresentacoes,
            addProdutoApresentacao,
            updateProdutoApresentacao,
            deleteProdutoApresentacao,
            fetchProdutoApresentacoes
        }}>
            {children}
        </ProdutoApresentacaoContext.Provider>
    );
};
